import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { StudyFinish } from './components/StudyFinish';
import { StudyStart } from './components/StudyStart';

export const LoginAction = () => {
  return (
    <AnalyticsCategoryProvider category={Categories.LOGIN}>
      <Routes>
        <Route path="study/finish/:id" element={<StudyFinish />} />
        <Route path="study/start/:id/*">
          <Route path=":accountId" element={<StudyStart />} />
          <Route path="*" element={<StudyStart />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </AnalyticsCategoryProvider>
  );
};
